<template>
  <div class="filter-container">
    <Form class="form-wrapper">
      <component
        :is="conf.component"
        v-for="(conf, index) in filteredConfig"
        :key="index"
        class="grid-component"
        :class="`grid-component-wrapper-${conf.gridComponent} ${conf.class}`"
        :value="values[conf.column]"
        v-bind="{ ...conf, ...$attrs }"
        @change="value => handleSearch(conf, value)"
        @on-change="value => handleSearch(conf, value)"
        @click="handleClick(conf)"
      />
    </Form>
  </div>
</template>

<script>
import { Form } from "ant-design-vue";

export default {
  data() {
    return {
      values: {},
      searchQuery: {},
      datePickerOpen: {}
    };
  },
  components: {
    Form
  },
  props: {
    config: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.setDefaultValues();
  },
  computed: {
    attrValue() {
      return this.$attrs.value || {};
    },
    filteredConfig() {
      return this.config.filter(conf => !conf.hide);
    }
  },
  methods: {
    setDefaultValues() {
      for (const [key, value] of Object.entries(this.attrValue)) {
        this.values = { [key]: value, ...this.values };
        const columnInfo = this.config.find(conf => conf["column"] === key);
        this.handleSearch(columnInfo, value, false);
      }
      this.emitChange();
    },
    handleSearch(config, value, emitChange = true) {
      this[`${config.searchType}Search`](
        config.column,
        value,
        emitChange,
        config.split
      );
    },
    handleClick(config) {
      if (!config.clickable) return;
      this[`handle${config.searchType}`]();
    },
    handleSubmit() {
      this.$emit("submit");
    },
    normalSearch(column, value, emitChange) {
      this.setValue(column, value, emitChange);
    },
    querySearch(column, { target: { value } }, emitChange) {
      this.setValue(column, value, emitChange);
    },
    radioSearch(column, { target: { value } }, emitChange) {
      this.setValue(column, value, emitChange);
    },
    arrayStringSearch(column, value, emitChange) {
      this.setValue(column, value, emitChange);
    },
    exceptionalSplitSearch(column, value, emitChange, split) {
      this.values = {
        ...this.values,
        [column]: value
      };
      if (value) {
        let formattedValue = value
          .split("-")
          .map(item => (Number(item) ? Number(item) : 0));
        if (formattedValue.length === 1)
          formattedValue = value
            .split("&")
            .map(item => (Number(item) ? Number(item) : 0));
        split.forEach((item, i) => {
          this.setValue(item, formattedValue[i], false);
        });
      } else {
        split.forEach((item, i) => {
          this.setValue(item, null, false);
        });
      }
      this.emitChange();
    },
    rangeSearch(column, value, emitChange) {
      this.values = {
        ...this.values,
        [column[0]]: value[0],
        [column[1]]: value[1]
      };
      this.searchQuery = {
        ...this.searchQuery,
        [column[0]]: value[0],
        [column[1]]: value[1]
      };
      if (!value[0] && !value[1])
        this.searchQuery = {
          ...this.searchQuery,
          [column[0]]: null,
          [column[1]]: null
        };
      emitChange && this.emitChange();
    },
    checkboxSearch(column, { target: { checked } }, emitChange) {
      this.setValue(column, checked, emitChange);
    },
    dateSearch(column, value, emitChange) {
      this.setValue(column, value, emitChange);
    },
    setValue(column, value, emitChange) {
      this.values = { ...this.values, [column]: value };
      this.searchQuery = {
        ...this.searchQuery,
        [column]: typeof value === "string" ? value.trim() : value
      };
      emitChange && this.emitChange();
    },
    emitChange() {
      this.$emit(`on-filter-change`, this.searchQuery);
    }
  },
  watch: {
    config: {
      immediate: true,
      handler: function(newVal) {
        newVal.forEach(conf => {
          if (conf.additionalData && typeof conf.additionalData === "object")
            this.searchQuery = { ...this.searchQuery, ...conf.additionalData };
        });
      }
    }
  }
};
</script>
